const centers = (list) => {
    const wrapper_centers = document.querySelector('[data-centers]');
    const wrapper_modals = document.querySelector('[data-centers-modals]');

    if (!wrapper_centers) return;
    
    list.sort((a, b) => (a.examinationAreaAddress > b.examinationAreaAddress ? 1 : -1)); 
    let content = '',
        modals = '',
        list_buttons = {};

    list.forEach((element) => {
        let name= element.examinationAreaAddress;    

        if (element.latitude && element.longitude) {
            let button = `<button type="button" data-open-modal="centers-modal-${element.examinationAreaId}" class="centers__item-block">г. ${name}${element.additionalAddressInfo ? `, ${element.additionalAddressInfo}` : ''}</button>`;
            let obj = {
                name: name.charAt(0),
                buttons: '' 
            }
                    
            if (list_buttons[name.charAt(0)]) {        
                list_buttons[name.charAt(0)][0].buttons = list_buttons[name.charAt(0)][0].buttons + button;
            } else {
                list_buttons[name.charAt(0)] = [];
                list_buttons[name.charAt(0)].push(obj);
                list_buttons[name.charAt(0)][0].buttons = button;
            }
    
            modals += `
                <div class="modal modal--preload" data-modal="centers-modal-${element.examinationAreaId}">
                    <div class="modal__wrapper">
                        <div class="modal__overlay" data-close-modal></div>
                        <div class="modal__content">      
                            <div class="exams__modal">
                                <h4>Центр тестирования в&nbsp;г.&nbsp;${name.split(',')[0]}</h4>
                                <div class="exams__modal-blocks">
                                    <div class="exams__modal-block">
                                        <p><strong>Экзаменационная площадка:</strong></p>
                                        ${element.examinationAreaFullName ? `<p>${element.examinationAreaFullName}</p>` : ''}
                                        ${element.linkToProcessingPersonalData ? `<a href="${element.linkToProcessingPersonalData}" class="exams__modal-buttons__link" target="_blank" rel="noopener noreferrer">Политика конфиденциальности</a>` : ''}
                                    </div>
                                    <div class="exams__modal-block">
                                        <p><strong>Адрес места проведения экзамена:</strong></p>
                                        <p>г. ${name}${element.additionalAddressInfo ? `, ${element.additionalAddressInfo}` : ''}</p>
                                    </div>
                                    <div class="exams__modal-block">
                                        <p><strong>Часы работы:</strong></p>
                                        ${element.openingHours ? `<p>${element.openingHours}</p>` : ''}
                                    </div>
                                    <div class="exams__modal-block">
                                        <p><strong>Контакты:</strong></p>
                                        ${element.contactPhone ? `<p>Телефон: <a href="tel:${element.contactPhone}">${element.contactPhone}</a></p>` : ''}
                                        ${element.contactEmail ? `<p>E-mail: <a href="mailto:${element.contactEmail}">${element.contactEmail}</a></p>` : ''}
                                    </div>
                                </div>
                                <div class="exams__modal-buttons">
                                    ${element.isRemoteSubmissionAvailable ? 
                                        `<a href="#form" data-close-modal class="btn" data-area="${element.examinationAreaId}">Записаться</a>` : 
                                        '<button data-close-modal disabled class="btn">Записаться</button>'
                                    }
                                    <a href="/area?id=${element.examinationAreaId}" target="_blank" class="btn-white exams__modal-button__desktop">Смотреть расписание экзаменов</a>
                                    <a href="/area?id=${element.examinationAreaId}" target="_blank" class="btn-white exams__modal-button__mobile">Расписание экзаменов</a>                                
                                </div>
                            </div>
                            <button class="modal__close-btn" type="button" aria-label="Закрыть попап" data-close-modal></button>
                        </div>
                    </div>
                </div>
            `
        }
    });      

    for (let key in list_buttons) {
        list_buttons[key].forEach(element => {
            content += `
                <li class="centers__item">
                    <h5>${element.name}</h5>
                    <div class="centers__item-blocks">
                        ${element.buttons}
                    </div>
                </li>
            `
        })
    }

    wrapper_modals.innerHTML = modals;
    wrapper_centers.innerHTML = content;
}

export default centers;